// src/pages/performance/manageAppraisals.utils.js
/* ---------------------------------------
   Utils
---------------------------------------- */
export function safeMsg(err, fallback = "Something went wrong") {
  return err?.response?.data?.message || err?.message || fallback;
}

export function cleanParams(params) {
  const out = { ...(params || {}) };
  Object.keys(out).forEach((k) => {
    if (out[k] === undefined || out[k] === null || out[k] === "") delete out[k];
  });
  return out;
}

/**
 * ✅ MUI X DataGrid valueGetter signature differs between versions:
 * - v5/v6: valueGetter(params)
 * - v7+:   valueGetter(value, row)
 */
export function rowFromValueGetterArgs(a, b) {
  if (a && typeof a === "object" && a.row) return a.row; // v5/v6
  return b || null; // v7+
}

export function normalizeToArray(payload) {
  const data = payload?.data ?? payload;

  if (Array.isArray(data)) return data;

  if (data && typeof data === "object") {
    if (Array.isArray(data.data)) return data.data;
    if (data.data && typeof data.data === "object" && Array.isArray(data.data.data)) return data.data.data;
    if (Array.isArray(data.items)) return data.items;
    if (Array.isArray(data.results)) return data.results;
  }

  return [];
}

export function buildWorkflowOptionsFromApi(list) {
  const base = [{ value: "", label: "Auto-select based on employee role (recommended)" }];

  const items = (list || [])
    .map((t) => {
      const slug = t?.slug || t?.workflow_template_slug || t?.value || "";
      const name = t?.name || t?.label || t?.title || slug || "—";
      return slug ? { value: String(slug), label: String(name) } : null;
    })
    .filter(Boolean);

  const seen = new Set();
  const uniq = [];
  for (const it of items) {
    if (seen.has(it.value)) continue;
    seen.add(it.value);
    uniq.push(it);
  }

  return base.concat(uniq);
}

export function workflowLabel(slug, options) {
  if (!slug) return "";
  const hit = (options || []).find((o) => o.value === slug);
  return hit?.label || slug;
}

/**
 * Normalize API responses for pages:
 * - array
 * - Laravel paginator/resource collection
 */
export function normalizePageResponse(payload) {
  const data = payload?.data ?? payload;

  if (Array.isArray(data)) return { rows: data, total: data.length };
  if (!data || typeof data !== "object") return { rows: [], total: 0 };

  if (data.data && typeof data.data === "object" && Array.isArray(data.data.data)) {
    const rows = data.data.data;
    const total =
      typeof data.data.total === "number"
        ? data.data.total
        : typeof data.data.meta?.total === "number"
        ? data.data.meta.total
        : rows.length;
    return { rows, total };
  }

  if (Array.isArray(data.data)) {
    const rows = data.data;
    const total =
      typeof data.total === "number" ? data.total : typeof data.meta?.total === "number" ? data.meta.total : rows.length;
    return { rows, total };
  }

  if (Array.isArray(data.items)) {
    const rows = data.items;
    const total = typeof data.total === "number" ? data.total : rows.length;
    return { rows, total };
  }

  if (Array.isArray(data.results)) {
    const rows = data.results;
    const total = typeof data.total === "number" ? data.total : rows.length;
    return { rows, total };
  }

  return { rows: [], total: 0 };
}

export function normalizeSingleResponse(payload) {
  const data = payload?.data ?? payload;
  if (!data || typeof data !== "object") return data;
  if (data.data && typeof data.data === "object" && !Array.isArray(data.data)) return data.data;
  if (data.item && typeof data.item === "object") return data.item;
  return data;
}
